import * as Styles from './styles';
import BannerItems from './BannerItems';
import {IconExpandLess} from 'cdk-radial';
import { BUTTON_SIZES, IconButton, ICON_SIZE } from 'cdk-radial';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function Banner(props: { closetColor: Function, hideBanner: Function, bannerData: any }) {
    return (
        <><Styles.BannerWrapper>
                <Styles.CarouselContainer data-testid="banner">
                    <Styles.CarouselCloseContainer>
                        <IconButton
                            data-testid="closeIcon"
                            icon={<IconExpandLess/>}
                            onClick={props.hideBanner}
                            size={BUTTON_SIZES.SMALL}
                            iconSize={ICON_SIZE.SMALL}
                            text=''
                        />
                    </Styles.CarouselCloseContainer>
                    {!!props?.bannerData?.length && <BannerItems closetColor={props.closetColor} bannerItems={props.bannerData}/>}
                </Styles.CarouselContainer>
            </Styles.BannerWrapper>
        </>
    );
}
